import { HttpClient } from '@angular/common/http';
import { inject, Injectable } from '@angular/core';
import { POCKETS_API_TOKEN } from './tokens';
import {
  Pocket,
  PocketsFilterResponseDto,
  PocketsRequestDto,
} from '@epicuro-next/models/pockets';

@Injectable()
export class PocketsService {
  private readonly httpClient = inject(HttpClient);
  private readonly pocketsV2Url = inject(POCKETS_API_TOKEN);

  public getPockets(query: PocketsRequestDto) {
    return this.httpClient.post<{ pockets: Pocket[] }>(
      `${this.pocketsV2Url}`,
      query,
    );
  }

  public getFilters(query: PocketsRequestDto) {
    return this.httpClient.post<PocketsFilterResponseDto>(
      `${this.pocketsV2Url}/filters`,
      query,
    );
  }
}
